module.exports = __webpack_public_path__ + "img/kv.86fb73f9.jpeg";